export default __webpack_public_path__ + "static/SRF Carasweet 5S7706 - Product Specifications & Technical Data-9da7b566b818c5472574de4261401e93.pdf";